import { color } from './color';

export const separator = {
	height: '1px',
	color: color.border.default,
};
